import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, MapPin } from "lucide-react";
import { api } from "@/lib/api";

// Carrousel « Trajets publiés près de toi » (proposition B).
export default function NearbyTripsCarousel({ city, onOpen }) {
  const [trips, setTrips] = useState([]);
  const [idx, setIdx] = useState(0);
  const ref = React.useRef(null);

  useEffect(() => {
    api.get("/price/trips/feed", { params: city ? { from_q: city } : {} })
      .then(({ data }) => setTrips((data?.trips || []).slice(0, 8)))
      .catch(() => setTrips([]));
  }, [city]);

  if (!trips.length) return null;
  const scrollBy = (d) => ref.current?.scrollBy({ left: d * ref.current.clientWidth * 0.8, behavior: "smooth" });
  const onScroll = () => {
    const el = ref.current;
    if (el) setIdx(Math.round(el.scrollLeft / (el.clientWidth * 0.72)));
  };

  return (
    <div className="mt-6" data-testid="client-nearby-trips">
      <div className="flex items-center justify-between">
        <h2 className="font-[Outfit] text-[17px] font-black leading-tight">Trajets publiés près de toi</h2>
        <div className="flex gap-1.5">
          <button type="button" onClick={() => scrollBy(-1)} className="street-press grid h-8 w-8 place-items-center rounded-full bg-white street-border-thin" data-testid="client-nearby-prev" aria-label="Précédent"><ChevronLeft className="h-4 w-4" strokeWidth={3} /></button>
          <button type="button" onClick={() => scrollBy(1)} className="street-press grid h-8 w-8 place-items-center rounded-full bg-white street-border-thin" data-testid="client-nearby-next" aria-label="Suivant"><ChevronRight className="h-4 w-4" strokeWidth={3} /></button>
        </div>
      </div>
      <div ref={ref} onScroll={onScroll} className="-mx-1 mt-3 flex snap-x snap-mandatory gap-3 overflow-x-auto px-1 pb-3 [scrollbar-width:none]">
        {trips.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={onOpen}
            className="street-press w-[72%] flex-none snap-start rounded-3xl bg-white p-4 text-left street-border street-shadow-sm"
            data-testid={`client-nearby-trip-${t.id}`}
          >
            <div className="truncate font-[Outfit] text-[15px] font-black leading-tight">{short(t.from_address)} → {short(t.to_address)}</div>
            <div className="mt-1 text-[11px] font-bold uppercase tracking-widest text-foreground/50">{fmtDay(t.date)} · {t.time}</div>
            <div className="mt-3 flex items-end justify-between gap-2">
              <span className="font-[Outfit] text-[22px] font-black text-primary">{Number(t.price_per_seat_eur || 0).toFixed(2).replace(".", ",")}€</span>
              {t.nearby_labels?.[0] && (
                <span className="inline-flex max-w-[60%] items-center gap-1 truncate rounded-full bg-emerald-100 px-2 py-1 text-[10px] font-black text-emerald-800 street-border-thin">
                  <MapPin className="h-3 w-3 flex-none" />{t.nearby_labels[0].replace(/ de .*$/, "")}
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
      <div className="flex justify-center gap-1.5">
        {trips.map((t, i) => (
          <span key={t.id} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-5 bg-primary" : "w-1.5 bg-foreground/25"}`} />
        ))}
      </div>
    </div>
  );
}

const short = (a) => (a || "").split(",")[0];
const fmtDay = (d) => {
  try { return new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "short", day: "numeric", month: "short" }); } catch { return d; }
};
